import { Verdict, WorkflowStepCode } from '@exam-management/graphql';
import { QuestionReviewWorkflowStepCode } from '@exam-management/task-management';

// TODO: fix import path to be './providers'
import { QuestionReviewResultVerdict } from './providers/question-review-task-question-details-form-provider/schema';

export const mappedVerdict = {
  [QuestionReviewResultVerdict.Approved]: Verdict.Approved,
  [QuestionReviewResultVerdict.Rejected]: Verdict.Rejected,
};

export const mappedQuestionReviewStatus = {
  [WorkflowStepCode.QuestionReviewTodo]: QuestionReviewWorkflowStepCode.QuestionReviewTodo,
  [WorkflowStepCode.QuestionReviewInReview]: QuestionReviewWorkflowStepCode.QuestionReviewInReview,
  [WorkflowStepCode.QuestionReviewReviewed]: QuestionReviewWorkflowStepCode.QuestionReviewReviewed,
  [WorkflowStepCode.QuestionReviewDone]: QuestionReviewWorkflowStepCode.QuestionReviewDone,
};
